import cssText from './dark.css';

export function configureDarkTheme(ace: AceAjax.Ace) {
  ace.define('ace/theme/dark', [], (require, exports, module) => {
    exports.isDark = true;
    exports.cssClass = 'ace-mode-dark';
    exports.cssText = cssText;
    const dom = require('../lib/dom');
    dom.importCssString(exports.cssText, exports.cssClass);
  });
}
